import styled from '@emotion/styled';

import Flex from '../../../Flex';

export const FlexWrapper = styled(Flex)`
  padding: 16px;
`;
